export default function numberFormat(num, decimalPlaces = 2) {
    if (isNaN(num)) return '0';
    // Split the number into integer and decimal parts
    const [integerPart, decimalPart] = parseFloat(num).toFixed(decimalPlaces).split('.');

    // Format the integer part with spaces between thousands
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // Return the formatted number
    return `${formattedInteger}.${decimalPart}`;
}
